import { useMemo, useState, useRef } from "react";
import useOnClickOutside from "@/hooks/useOnClickOutside";

const useAlgoliaSorting = (t, currentRefinement, setCurrentRefinement) => {
  const sortMenuRef = useRef();
  const [show, setShow] = useState(false);

  useOnClickOutside([sortMenuRef], () => show && setShow(false));

  // Sorting options
  const optionsData = useMemo(
    () => [
      {
        id: 1,
        label: t("Recommended"),
        value: process.env.NEXT_PUBLIC_ALGOLIA_IDX_AR,
      },
      {
        id: 2,
        label: t("LowestPrice"),
        value: process.env.NEXT_PUBLIC_ALGOLIA_IDX_ASC_AR,
      },
      {
        id: 3,
        label: t("HighestPrice"),
        value: process.env.NEXT_PUBLIC_ALGOLIA_IDX_DESC_AR,
      },
      {
        id: 4,
        label: t("HighestDiscount"),
        value: process.env.NEXT_PUBLIC_ALGOLIA_IDX_Discount_AR,
      },
    ],
    [t]
  );

  // Find selected option
  const selectedOption = useMemo(
    () => optionsData.find((e) => e?.value === currentRefinement),
    [optionsData, currentRefinement]
  );

  const handleSelection = (value) => {
    setCurrentRefinement(value);
    setShow(false);
  };

  return {
    sortMenuRef,
    show,
    setShow,
    optionsData,
    selectedOption,
    handleSelection,
  };
};

export default useAlgoliaSorting;
